import { LoginModal } from "common/styleguide/LoginModal";
import { Overlay } from "common/styleguide/Overlay";
import React from "react";

export const LOGIN_MODAL_OVERLAY = "LOGIN_MODAL_OVERLAY";

export const LoginModalOverlay = ({ maxWidth = 410, maxHeight = 800, onRequestClose, ...props }) => (
  <Overlay maxWidth={maxWidth} maxHeight={maxHeight} onRequestClose={onRequestClose}>
    <LoginModal {...props} onRequestClose={onRequestClose} />
  </Overlay>
);
